import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import { TaDrsInstructionService } from '../../services/wealthlane-award-services';

const usePostToTransferAllocate = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseMutationResult<
  // eslint-disable-next-line camelcase
  any | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        TaDrsInstructionService.postApiAwardApiAppTaDrsInstructionToTransferAllocate(payload)
      );
    },
    {
      onSuccess: async (response: any | undefined) => {
        if (response != null) {
          toast.success(<ToastComponent label='Success' message='Transfer Allocated.' />);
          await queryClient.invalidateQueries('getParticipantCashTransferList');
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostToTransferAllocate;
